export default __webpack_public_path__ + "static/media/bold.4c333d1b.svg";